import { combineReducers } from "redux";

import image_type from "../features/admin/image_types/type/Slice";
import image from "../features/admin/image_types/image/Slice";
import common from "../features/admin/common/Slice";

const imagetypes = combineReducers({
  image_type,
  image,
  common,
});

export default imagetypes;